export default __webpack_public_path__ + "static/media/edit.dfba61e9.svg";